
export const TimersConfig = {
    actualValuesFrequencyInMs: 5 * 60 * 1000,
    activePowerForecastFrequencyInMs: 5 * 60 * 1000,
    activePowerFrequencyInMs: 5 * 60 * 1000,// 5 * 60 * 1000
    tariffFrequencyInMs: 60 * 60 * 1000 // 60 * 60 * 1000
}